import { useSearchParams } from "react-router-dom";
import { PageHeader } from "../../components/common";
import { GROWTH_TABS } from "../../lib/growthTabs";
import { Tabs, TabsContent } from "../../components/ui/tabs";
import { Opportunities, Packages, Loyalty } from "./growth/Retention";
import { Bookings, Coupons } from "./growth/Sales";
import { Scorecard, Stock } from "./growth/Ops";
import { Pricing, Analytics } from "./growth/Market";
import AutoAssign from "./growth/AutoAssign";
import Brief from "./growth/Brief";
import QrLabels from "./growth/QrLabels";
import GSettings from "./growth/GSettings";

const COMPONENTS = {
  opp: Opportunities, book: Bookings, coupon: Coupons, pkg: Packages, loyal: Loyalty, score: Scorecard, stock: Stock,
  price: Pricing, an: Analytics, aa: AutoAssign, brief: Brief, qr: QrLabels, set: GSettings,
};
const TABS = GROWTH_TABS.map(([k, l]) => [k, l, COMPONENTS[k]]);

export default function Growth() {
  const [params] = useSearchParams();
  const tab = TABS.some(([k]) => k === params.get("tab")) ? params.get("tab") : "opp";
  const title = (TABS.find(([k]) => k === tab) || [])[1] || "";
  return (
    <div className="space-y-6" data-testid="growth-page">
      <PageHeader eyebrow="Büyüme Merkezi" title={title} subtitle="Müşteriyi geri kazanma, randevu, kupon/sadakat, usta performansı ve pazar analizi — alt bölümler soldaki menüde." />
      <Tabs value={tab}>
        {TABS.map(([k, , C]) => <TabsContent key={k} value={k} className="mt-0"><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
